<template>
	<div class="home-page-echarts">
		<div id="echartId" style="height:100%;"></div>
	</div>
</template>

<script>
  import html2canvas from "html2canvas";

  export default {
    data() {
      return {
        myChart: null,
        echartData: []
      };
    },
    props: ['params'],
    mounted() {
      this.getStat();
    },
    watch: {
      params() {
        this.getStat();
      }
    },
    methods: {
      getStat() {
        this.$get("stat", this.params).then(res => {
          this.echartData = [];
          res.data.data.forEach(item => {
            this.echartData.push({
              name: item.deptName,
              value: [item.hospitalLongitude, item.hospitalLatitude, item.num, item.hospitalAddress, item.piNum],
              itemStyle: {
                normal: {
                  color: "#428ef7",
                  shadowBlur: 10,
                  shadowColor: "#333"
                }
              },
              logoImg: item.logoImg
            });
          });
          this.initEcharts();
        });
      },
      initEcharts() {
        this.myChart = this.$echarts.init(document.getElementById("echartId"));
        // 绘制图表
        this.myChart.setOption({
          backgroundColor: "#e1e1e1", //#428ef7
          title: {
            text: "",
            subtext: "",
            sublink: "",
            left: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: (params, ticket, callback) => {
              let resHtml = [];
              resHtml.push('<div style="font-size: 12px;">' + params.data.name + '</div>');
              resHtml.push('<div style="font-size: 12px; padding-bottom: 3px;">地址：' + params.value[3] + '</div>');
              resHtml.push('<div style="font-size: 12px;">患者数量：' + params.value[2] + '</div>');
              resHtml.push('<div style="font-size: 12px;">就诊流程数量：' + params.value[4] + '</div>');
              return resHtml.join('');
            }
          },
          geo: {
            map: 'china',
            roam: true,
            zoom: 1.2,
            label: {
              show: true
            },
            itemStyle: {
              normal: {
                areaColor: '#f3f3f3',
                borderColor: '#b1b1b1',//线
                // shadowColor: '#edeef0',//外发光
                // shadowBlur: 4
              },
				      emphasis: {
                areaColor: '#f3f3f3',//悬浮区背景
              }
            }
          },
          series: [
            {
              name: "Top 5",
              type: "effectScatter",
              coordinateSystem: "geo",
              data: this.echartData,
              symbol: (value, params) => {
                return `image://${params.data.logoImg}`;
                // image://http://xxx.a/b.png' 'image://data:image/gif;base64,R0lGODlhEAA...'
              },
              symbolSize: "20",
              rippleEffect: {
                period: 0
              },
              hoverAnimation: true,
              zlevel: 1
            }
          ]
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.home-page-echarts {
		height: 550px;
    margin-bottom: 50px;
		width: 100%;
		position: relative;
		.btn-down-img {
			position: absolute;
			right: 10px;
			top: 10px;
			z-index: 10;
		}
	}
</style>